export default "/images/57f9a6bb6517cb76bffa7e2c5ac4d6e3.avif";